import { render, staticRenderFns } from "./TsuIcon.vue?vue&type=template&id=379da52c&"
import script from "./TsuIcon.vue?vue&type=script&lang=js&"
export * from "./TsuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379da52c')) {
      api.createRecord('379da52c', component.options)
    } else {
      api.reload('379da52c', component.options)
    }
    module.hot.accept("./TsuIcon.vue?vue&type=template&id=379da52c&", function () {
      api.rerender('379da52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/atoms/TsuIcon.vue"
export default component.exports